import { Article } from '../../../api/newsfeed.types'
import { ArticlesItemAction } from './articles.item.types'

export const articlesItemRequestAction = (params: { article_id: number }): ArticlesItemAction => ({ type: 'ARTICLES_ITEM_REQUEST', params })
export const articlesItemSuccessAction = (article: Article): ArticlesItemAction => ({ type: 'ARTICLES_ITEM_SUCCESS', params: article })
export const articlesItemFailureAction = (error?: any): ArticlesItemAction => ({ type: 'ARTICLES_ITEM_FAILURE', params: error })